import { render, staticRenderFns } from "./CreditApplication.vue?vue&type=template&id=2c8b4f10&"
import script from "./CreditApplication.vue?vue&type=script&lang=js&"
export * from "./CreditApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports